import { gql } from '@/__generated__/gql';

export const CREATE_BANK_ACCOUNT_MUTATION = gql(`
  mutation EnterBankAccountInfoModalPageCreateBankAccount($input: CreateBankAccountInput!) {
    createBankAccount(input: $input) {
      id
    }
  }
`);

export const UPDATE_BANK_ACCOUNT_MUTATION = gql(`
  mutation EnterBankAccountInfoModalPageUpdateBankAccount($input: UpdateBankAccountInput!) {
    updateBankAccount(input: $input) {
      id
    }
  }
`);

export const DELETE_BANK_ACCOUNT_MUTATION = gql(`
  mutation EnterBankAccountInfoModalPageDeleteBankAccount($id: ID!) {
    deleteBankAccount(id: $id)
  }
`);
